module.exports = __webpack_public_path__ + "enlarge-spend-white.svg?7eb5df1db2013b298d85731f43c24bfd";